import React from "react"
import Responsive from "react-responsive"

import TransactionsHistory from "./TransactionsHistory"

const Desktop = props => <Responsive {...props} minWidth={1000} />
const Mobile = props => <Responsive {...props} maxWidth={999} />

const Section4 = () => {
  const hrefSymbol = "#"

  return (
    <section className="section4">
      <div className="section4-info">
        <h3 className="section4-info-title">
          <span>Never be surprised</span> by any transactions
        </h3>
        <TransactionsHistory />{" "}
        <a href={hrefSymbol} className="section4-info-learnMore">
          Learn more >
        </a>
      </div>

      <div className="section4-image">
        <Desktop>
          <img
            className="section4-UI"
            src="/images/Section4/transactions-history-desktop.png"
            alt="Payment providers desktop"
          />
        </Desktop>
        <Mobile>
          <img
            className="section4-UI"
            src="/images/Section4/transactions-history-mobile.png"
            alt="Payment providers mobile"
          />
        </Mobile>
        <h1 className="section4-UI-title">Transactions History</h1>
      </div>
    </section>
  )
}

export default Section4
